import type { ProjectionHorizon } from '@/lib/projectScore';

const HORIZONS = ['now', '+1Y', '+2Y'] as const;

interface Props {
  projectionHorizon: ProjectionHorizon | undefined;
  onProjectionChange: (horizon: ProjectionHorizon) => void;
}

export function ProjectionSelector({ projectionHorizon, onProjectionChange }: Props) {
  return (
    <div className="absolute top-2 left-3 z-10 flex items-center gap-1">
      <span className="text-[10px] text-gray-400 mr-1 font-medium">Forward:</span>
      {HORIZONS.map(h => {
        const isActive = (projectionHorizon ?? 'now') === h;
        return (
          <button
            key={h}
            onClick={() => onProjectionChange(h)}
            className={`text-[10px] px-2 py-0.5 rounded font-semibold transition-colors ${
              isActive
                ? h === 'now' ? 'bg-gray-800 text-white' : 'bg-purple-600 text-white'
                : 'bg-gray-100 text-gray-400 hover:bg-gray-200 cursor-pointer'
            }`}
          >
            {h === 'now' ? 'Now' : h}
          </button>
        );
      })}
    </div>
  );
}
